import { render } from "./Login.vue?vue&type=template&id=20d334b2&scoped=true"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import "./Login.vue?vue&type=style&index=0&id=20d334b2&lang=scss&scoped=true"

import exportComponent from "/var/lib/docker/jenkins_home/workspace/play-spider-web-prod-s3-deploy/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20d334b2"]])

export default __exports__